import { ProductSubCategoryEnum, ProductUsageEnum } from "@shared/enums";

// General listing policy, independent of product type. Remove entries to disable options.
export const PRODUCT_SUB_CATEGORY_FILTER_WHITELIST: readonly ProductSubCategoryEnum[] = [
  ProductSubCategoryEnum.FISH_EYE,
  ProductSubCategoryEnum.WIDE_ANGLE,
  ProductSubCategoryEnum.STANDARD,
  ProductSubCategoryEnum.TELEPHOTO,
  ProductSubCategoryEnum.SUPER_TELEPHOTO,
  ProductSubCategoryEnum.SUPERZOOM,
];

export const PRODUCT_USAGE_FILTER_WHITELIST: readonly ProductUsageEnum[] = [
  ProductUsageEnum.LANDSCAPE,
  ProductUsageEnum.SPORT,
  ProductUsageEnum.WILDLIFE,
  ProductUsageEnum.VIDEO,
  ProductUsageEnum.STREET,
  ProductUsageEnum.PORTRAIT,
  ProductUsageEnum.REPORTAGE,
  ProductUsageEnum.TRAVEL,
  ProductUsageEnum.MACRO,
  ProductUsageEnum.STUDIO,
  ProductUsageEnum.ASTRO,
];

export const PRODUCT_USAGE_FILTER_MIN_SCORE = 75;
